<div class="compliance-container d-lg-block d-none">
	<div class="compliance-container-inner">
		<img
			class="d-none d-md-block orange-pattern-overlay"
			src="../../assets/img/orange-pattern.png"
			alt=""
		/>
		<img
			class="d-md-none orange-pattern-overlay"
			src="../../assets/img/orange-pattern-mobile.png"
			alt=""
		/>
		<div class="container text-center">
			<h2 class="compliance-header">Rethink Compliance</h2>

			<div class="row">
				<div class="col-md-4 mb-5 mb-lg-0">
					<img
						class="challenges-list-img"
						src="../../assets/img/simplify-documentation.svg"
						alt=""
					/>
					<div class="challenges-list-head">
						Simplify Documentation
					</div>
					<div class="challenges-list-content">
						Wizard-driven experience to generate
						<br class="d-none d-xl-block" />
						artifacts with a few clicks.
					</div>
				</div>
				<div class="col-md-4 mb-5 mb-lg-0">
					<img
						class="challenges-list-img"
						src="../../assets/img/integrate-everything.svg"
						alt=""
					/>
					<div class="challenges-list-head">
						Integrate with Everything
					</div>
					<div class="challenges-list-content">
						Easily ingest and export data with no
						<br class="d-none d-xl-block" />
						vendor lock-in using our open APIs.
					</div>
				</div>
				<div class="col-md-4 mb-5 mb-lg-0">
					<img
						class="challenges-list-img"
						src="../../assets/img/deliver-compliance.svg"
						alt=""
					/>
					<div class="challenges-list-head">Deliver Compliance</div>
					<div class="challenges-list-content">
						Formally schedule audits, document issues,
						<br class="d-none d-xl-block" />
						attach evidence and track corrective actions.
					</div>
				</div>
			</div>
			<a href="https://go.regscale.com/RegScale-Create-Account">
				<button class="complaince-button py-2 px-5 mt-2 mt-lg-5">
					Find Out More
				</button></a
			>
		</div>
	</div>
</div>
